// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__18LNC","content":"Consent_content__3cHgh","footer":"Consent_footer__1ZOAX"};